/** Pictures coming onto the board: the size each comes in with (its own proportions, never too big). */
import { IMAGE_ELEMENT } from "../../../shared/elements";
import { PICTURE_MIN_SIDE, PICTURE_SIDE } from "./constants";

/** The size a picture at `src` comes in with: its own proportions, at most {@link PICTURE_SIDE} on its longer side. */
export async function pictureSize(src: string): Promise<{ w: number; h: number }> {
  try {
    const img = new Image();
    img.src = src;
    await img.decode();
    const [w, h] = [img.naturalWidth, img.naturalHeight];
    if (!w || !h) return IMAGE_ELEMENT.usual.size;
    const scale = Math.min(1, PICTURE_SIDE / Math.max(w, h));
    return { w: Math.max(PICTURE_MIN_SIDE, Math.round(w * scale)), h: Math.max(PICTURE_MIN_SIDE, Math.round(h * scale)) };
  } catch {
    return IMAGE_ELEMENT.usual.size;
  }
}
